$(document).on('click', '.js-show-more-child-categories', function(){
    $(this).fadeOut(function(){
        $(this).remove();
        $('.child-categories__item').fadeIn();
    });
})

const rangeInput = $('.js-price-filter-range');
if(rangeInput.length){

    /* prevent write forbiden characters to number input */
    $('.js-price-filter-input').on('keydown', function(e) {
        if (['-', '+', 'e'].includes(e.key)) {
            e.preventDefault();
        }
    });

    const priceInput = $('.js-price-filter-input');
    const progress = $('.js-price-filter-progress');
    let priceGap = 0;

    const overlapping = (rangeInput[1].max - rangeInput[0].min) * 0.1;

    $(document).on('input', '.js-price-filter-input' ,function(){
        let minVal = parseInt(priceInput[0].value);
        let maxVal = parseInt(priceInput[1].value);
        let error = false;

        if(minVal > rangeInput[1].max){
            if(maxVal > rangeInput[1].max){
                priceInput[0].value = rangeInput[1].max;
            }else{
                priceInput[0].value = maxVal;
                $(rangeInput[0]).css('z-index', 1);
            }

            minVal = maxVal;
        }else{

            /* prevent max to be lower then min */
            if(maxVal < minVal){
                priceInput[1].classList.add('error');
                error = true;
            }
        }

        if(maxVal > rangeInput[1].max){
            priceInput[1].value = rangeInput[1].max;
            maxVal = rangeInput[1].max;
            // priceInput[1].classList.add('error');
            // error = true;
        }

        if(minVal < rangeInput[0].min){
            //priceInput[1].value = rangeInput[0].max;
            priceInput[0].classList.add('error');
            error = true;
        }else{
            priceInput[0].classList.remove('error');
        }

        priceInput[1].min = minVal;
        if(maxVal > rangeInput[1].max){
            priceInput[0].max = rangeInput[1].max;
        }else{
            priceInput[0].max = maxVal;
        }


        if((maxVal - minVal >= priceGap) && maxVal <= rangeInput[1].max){
            if($(this).hasClass('input-min')){
                rangeInput[0].value = minVal;
                let new_left = (minVal - rangeInput[0].min) / (rangeInput[1].max - rangeInput[0].min) * 100;
                if(new_left < 0){
                    new_left = 0;
                }
                progress.css('left', new_left + '%');
            }else{
                rangeInput[1].value = maxVal;
                let new_right = 0
                if(maxVal != rangeInput[1].max){
                    new_right = 100 - ((maxVal - rangeInput[0].min ) / (parseInt(rangeInput[0].min) - rangeInput[0].max )) * 100 * -1 + '%'
                }
                progress.css('right',new_right);
            }
        }

        if(!error){
            priceInput[0].classList.remove('error');
            priceInput[1].classList.remove('error');
            prepare_to_filter();
        }
    });

    $(document).on('input', '.js-price-filter-range' ,function(){
        let minVal = parseInt(rangeInput[0].value);
        let maxVal = parseInt(rangeInput[1].value);

        if($(this).hasClass('range-min')){
            if(maxVal - minVal < overlapping ){
                $(rangeInput[0]).css('z-index', 1);
            }
        }else{
            if(maxVal - minVal < overlapping ){
                $(rangeInput[0]).css('z-index', '');
            }
        }

        if((maxVal - minVal) < priceGap){
            if($(this).hasClass('range-min')){
                rangeInput[0].value = maxVal - priceGap
            }else{
                rangeInput[1].value = minVal + priceGap;
            }
        }else{
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            let new_left = (minVal - rangeInput[0].min) / (rangeInput[1].max - rangeInput[0].min) * 100 + "%";

            let new_right = 0
            if(maxVal != rangeInput[1].max){
                new_right = 100 - ((maxVal - rangeInput[0].min ) / (parseInt(rangeInput[0].min) - rangeInput[0].max )) * 100 * -1 + '%'
            }
            progress.css('left', new_left);
            progress.css('right', new_right);
            prepare_to_filter();
        }
    });
}

function reset_price_filter(){
    let price_inputs = $('.js-price-filter-input');
    let price_range = $('.js-price-filter-range');
    let price_progress = $('.js-price-filter-progress');
    if(price_inputs.length){
        price_inputs[0].value = price_inputs[0].min;
        price_inputs[1].value = price_inputs[1].max;
        price_range[0].value = price_inputs[0].min;
        price_range[1].value = price_inputs[1].max;
        price_progress.css('left', 0);
        price_progress.css('right', 0);
    }
}
